import { render, staticRenderFns } from "./RopePickingBoatMaster.vue?vue&type=template&id=62ef152f&scoped=true&"
import script from "./RopePickingBoatMaster.vue?vue&type=script&lang=js&"
export * from "./RopePickingBoatMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef152f",
  null
  
)

export default component.exports